import React, { Component } from 'react'
import { connect } from 'react-redux'
import MarketIndexMobile from './MarketIndex.mobile';

class Market_HK_Mobile extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        charts: [
            { exchangeID: "HK", key: "HSI" },
            { exchangeID: "HK", key: "HSCEI" },
            { exchangeID: "HK", key: "HSTECH" },
            { exchangeID: "HK", key: "HSCCI" },
        ]
    }

    componentDidMount(){
        
    }

    render(){
        const { charts } = this.state
        return(
        <>
            <MarketIndexMobile data = {charts}/>
        </>
        )
    }
}

export default connect(
    state => ({
      language: state.app.language,
      mdsToken: state.trade.mdsToken,
      theme: state.app.theme,
      isMobile: state.app.isMobile,
    }),
    dispatch => ({})
)(Market_HK_Mobile)